export default {
  zh: {
    refund: {
      refund: "退款发票",
      title: "Debit Invoice 借记发票",
      totalDue: "Total Due (GST included) 待返款总额(含税价)",
    },
    unpaid: {
      unpaid: "待支付发票",
      title: "Invoice 发票",
      totalDue: "Total Due (GST included) 待支付总额(含税价)",
      instruction: "Payment Instruction 支付信息: ",
      payable01: "Please make cheque payable to EStar Business Services Pte. Ltd.",
      payable02: "Or payment can be remitted direct into below account of EStar Business Services Pte. Ltd.",
      bankName: "Bank Name (收款行名称)：",
      bankAddress: "Bank Address (收款行地址)：",
      swiftCode: "Swift Code (Swift 代码)：",
      accountName: "Account Name (收款人名称)：",
      beneficiary: "Address of Beneficiary (收款人地址)：",
      accountNumber: "Account Number (收款人账号)：",
    },
    common: {
      generalInvoice: "发票",
      creditInvoice: "退款发票",
      date: "DATE 日期: ",
      invoice: "Invoice 发票 #: ",
      transaction: "Transaction No. 交易号码: ",
      dueDate: "Due Date: 到期日期: ",
      companyAddress: "公司地址",
      to: "To:",
      name: "Name 姓名: ",
      address: "Address 地址: ",
      country: "Country 国家: ",
      code: "Code 邮编: ",
      attention: "Attention 寄至: ",
      department: "Accounts Department 财务部",
      description: "DESCRIPTION 描述",
      rate: "RATE 比率",
      amount: "AMOUNT 金额",
      refund: "Refund of 退款明细: ",
      directorFee: "- Director Fee 董事费用",
      serviceFee: "- Service Fee 服务费用",
      less: "Less 扣除: ",
      handlingFee: "- Handling Fee 手续费用",
      remarks: "Remarks 备注",
      transactionNo: "Transaction No. 交易号码: ",
      serviceType: "Service Type 服务类型: ",
      ofWhich: "Of which 其中，",
      subtotal: "Subtotal 小计",
      taxable: "Taxable 应纳税额",
      taxRate: "Tax rate 税率",
      taxDue: "Tax due 应付税金",
      other: "Other 其他",
      hint: "This is an electronically generated receipt.  No signature is required. 这是一张电子收据，不需要签名。",
      setUp: "Company Incorporation 公司设立",
      transfer: "Corporate Service Transfer 公司转让",
      comprehensive: "Comprehensive Corporate Services 综合性公司服务",
      serviceCharge: "Service Charge 服务费",
      thirdpartyFee: "Third Party Fee 第三方费用",
      otherFee: "Other Fee 其他费用",
    },
    amends: {
      nature: "Supplemental 补款理由: ",
      serviceCharge: "Service Charge 服务费",
      thirdpartyFee: "Third Party Fee 第三方费用",
    },
    quotationV: {
      invoiceVariation: "Invoice Variation 价格变更",
    },
  },
  en: {
    refund: {
      refund: "Refund",
      title: "Debit Invoice",
      totalDue: "Total Due (GST included)",
    },
    unpaid: {
      unpaid: "Unpaid",
      title: "Invoice",
      totalDue: "Total Due (GST included)",
      instruction: "Payment Instruction: ",
      payable01: "Please make cheque payable to EStar Business Services Pte. Ltd.",
      payable02: "Or payment can be remitted direct into below account of EStar Business Services Pte. Ltd.",
      bankName: "Bank Name：",
      bankAddress: "Bank Address: ",
      swiftCode: "Swift Code: ",
      accountName: "Account Name: ",
      beneficiary: "Address of Beneficiary: ",
      accountNumber: "Account Number: ",
    },
    common: {
      generalInvoice: "Invoice",
      creditInvoice: "Credit Invoice",
      date: "DATE: ",
      invoice: "Invoice #: ",
      transaction: "Transaction No: ",
      dueDate: "Due Date: ",
      companyAddress: "Company Address",
      to: "To:",
      name: "Name: ",
      address: "Address: ",
      country: "Country: ",
      code: "Code: ",
      attention: "Attention: ",
      department: "Accounts Department",
      description: "DESCRIPTION",
      rate: "RATE",
      amount: "AMOUNT",
      refund: "Refund of: ",
      directorFee: "- Director Fee",
      serviceFee: "- Service Fee",
      less: "Less: ",
      handlingFee: "- Handling Fee",
      remarks: "Remarks",
      transactionNo: "Transaction No: ",
      serviceType: "Service Type: ",
      ofWhich: "Of which,",
      subtotal: "Subtotal",
      taxable: "Taxable",
      taxRate: "Tax rate",
      taxDue: "Tax due",
      other: "Other",
      hint: "This is an electronically generated receipt. No signature is required.",
      setUp: "Company Incorporation",
      transfer: "Corporate Service Transfer",
      comprehensive: "Comprehensive Corporate Services",
      serviceCharge: "Service Charge",
      thirdpartyFee: "Third Party Fee",
      otherFee: "Other Fee",
    },
    amends: {
      nature: "Supplemental Nature: ",
      serviceCharge: "Service Charge",
      thirdpartyFee: "Third Party Fee",
    },
    quotationV: {
      invoiceVariation: "Invoice Variation",
    },
  },
};
